// extracted by mini-css-extract-plugin
export default {"right":"Right_right__OqSpJ","uploadWrapper":"Right_uploadWrapper__50AUP","mobile":"Right_mobile__4NA2F"};